
    import Component from "vue-class-component";
    import Vue from "vue";
    import {FileModel } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import {BvTableFieldArray} from "bootstrap-vue";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";

    @Component({
         components: {
            TableEmptySlot
        }
    })
    export default class Files extends Vue {

        @Prop({ default: () => ([]) })
        existingFiles!: FileModel[];

        @Prop({ default: () => ([]) })
        removedFiles!: FileModel[];

        @Prop()
        downloadUrlFactory!: (fileId: string) => Promise<string>;

        @Prop({ default: () => false})
        filesCanBeRemoved!: boolean;

        @Prop({default: true})
        showTitle!: boolean;

        // Keep this method synchronous to avoid popup blocking in firefox
        downloadFile(fileId: string) {
            const downloadWindow = window.open();
            this.downloadUrlFactory(fileId)
                .then(downloadUrl => {
                downloadWindow!.location.href = downloadUrl; // Start file download in a new tab
                window.setTimeout(function(){
                    downloadWindow!.close();
                }, 1000);
            });
        }

        created(){
          this.$watch(() => this.existingFiles, files => {
            this.$emit("input", files);
          })

          this.$watch(() => this.removedFiles, files => {
            this.$emit("input", files);
          })
        }

        deleteFile(file: FileModel) {
          this.$delete(this.existingFiles, this.existingFiles.indexOf(file));
          this.removedFiles.push(file);
          this.$emit("file-removed", file);
        }

        fileFields: BvTableFieldArray = [
            { key: 'name', label: this.$ls.Components_Files_Table_Label_FileName, sortable: false },
            { key: 'actions', label: '', headerTitle: 'actions', sortable: false, tdClass:"table-actions"},
        ]
    }
